export var SamsungPayButtonColorEnumsObj = {
    BLACK: "black",
    WHITE: "white",
};
